export const mergeFrameworkTypesAndMetadata = ({
  frameworkTypes,
  metadata
}) => frameworkTypes.map(frameworkType => Object.assign({}, frameworkType, {
  typeMetadata: metadata[frameworkType.fullyQualifiedName] || null
}));